"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMENTS_MAPPING = {
    prefix: 'comments',
    addComment: {
        path: '/addComment'
    },
    updateComment: {
        path: '/updateComment',
        parameter: '/:commentId'
    },
    deleteComment: {
        path: '/deleteComment',
        parameter: '/:commentId'
    },
    getCommentsList: {
        path: '/getCommentsList',
        parameter: '/:statementId'
    }
};
